module.exports = __webpack_public_path__ + "static/media/DrillingRigCompressed.ed2edf9b.jpg";